export default "__VITE_ASSET__Qthp0Iw6__"